import {
  fetchSurveyQuestionsTypes,
  addSurveyQuestionTypes,
  updateSQuestionTypes,
  addSQuestionOptionTypes,
  removeSQuestionOptionTypes,
  removeSQuestionTypes,
} from './action_types';

import {
  FETCH_SURVEY_QUESTIONS_QUERY,
  ADD_SURVEY_QUESTION_MUTATION,
  UPDATE_S_QUESTION_MUTATION,
  // ADD_S_QUESTION_OPTION_MUTATION,
  // REMOVE_S_QUESTION_OPTION_MUTATION,
  REMOVES_S_QUESTION_MUTATION,
} from './api';

import { makeQuery, makeMutation } from '../../config/client';

export const fetchSurveyQuestions = variables => makeQuery(variables)(
  fetchSurveyQuestionsTypes,
  FETCH_SURVEY_QUESTIONS_QUERY
);

export const addSurveyQuestion = variables => makeMutation({ variables })(
  addSurveyQuestionTypes,
  ADD_SURVEY_QUESTION_MUTATION
);

export const updateSQuestion = variables => makeMutation({ variables })(
  updateSQuestionTypes,
  UPDATE_S_QUESTION_MUTATION
);

// export const addSQuestionOption = variables => makeMutation({ variables })(
//   addSQuestionOptionTypes,
//   ADD_S_QUESTION_OPTION_MUTATION
// );
//
// export const removeSQuestionOption = variables => makeMutation({ variables })(
//   removeSQuestionOptionTypes,
//   REMOVE_S_QUESTION_OPTION_MUTATION
// );

export const removeSQuestion = variables => makeMutation({ variables })(
  removeSQuestionTypes,
  REMOVES_S_QUESTION_MUTATION
);



// WEBPACK FOOTER //
// ./src/modules/survey/actions.js